export default __webpack_public_path__ + "static/media/small Green.5f8b160b.png";